import { checkoutShippingOrderNotesEntryStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingOrderNotesEntry";
import { contentSpacingStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

Object.assign(checkoutShippingOrderNotesEntryStyles, {
    textArea: {
        cssOverrides: {
            formField: css`
                ${contentSpacingStyles(null, "1.25em")}
                textarea {
                    vertical-align: middle;
                }
            `,
        },
    },
});
